import React from 'react';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import MagicForm from '../../../../../Components/Form/MagicForm';

interface Props {
	formScheme: ItemScheme[];
	onSubmit: (values: any) => void;
	submitButtonText: string;
	defaultValues?: object;
}

const ManagerWorkplaceForm: React.FC<Props> = ({
	formScheme,
	onSubmit,
	submitButtonText,
	defaultValues,
}) => {
	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={onSubmit}
			submitText={submitButtonText}
			defaultValues={defaultValues}
		/>
	);
};

export default ManagerWorkplaceForm;
